import { Modal } from "react-bootstrap";
import Icons from "../myIcon/Icons";
import { BaseUrl } from "../helper/BaseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function EnquiryPopup({ show, onHide }) {
    const navigate = useNavigate();
    const [ip, setIp] = useState("");
    const [loading, setLoading] = useState(false);

    const [postData, setPostData] = useState({ name: "", email: "", mobile: "", location: "", messages: "", address: "", project_type: "", item_requirement: "", source_url: sessionStorage.getItem("first_landing_url"), ip_address: ip, });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setPostData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    useEffect(() => {
        // Get IP address on component load
        const fetchIp = async () => {
            const res = await fetch("https://api.ipify.org?format=json");
            const data = await res.json();
            setIp(data.ip);
        };
        fetchIp();
    }, []);

    // Submit handler
    const handleSubmit = async (e) => {
    e.preventDefault();

    for (const [key, value] of Object.entries(postData)) {
        if (
        key !== "source_url" &&
        key !== "ip_address" &&
        key !== "messages" &&
        (value === "" || value === null)
        ) {
        toast.error(`The field "${key}" is mandatory.`);
        return;
        }
    }

    if (!/^[0-9]+$/.test(postData.mobile)) {
        toast.error("Phone Number should contain only digits.");
        return;
    }

    if (postData.mobile.length !== 10) {
        toast.error("Phone Number should be exactly 10 digits long.");
        return;
    }

    const payload = {
        ...postData,
        ip_address: ip,
        source_url: sessionStorage.getItem("first_landing_url"),
    };

    setLoading(true);

    try {
        await axios.post(`${BaseUrl}/api/contact-saves`, payload);
        onHide();
        navigate("/thankyou");
        setPostData({ name: "", email: "", mobile: "", location: "", messages: "", address: "", project_type: "", item_requirement: "", source_url: sessionStorage.getItem("first_landing_url"), ip_address: ip, });

    } catch (error) {
        console.error("Error submitting form:", error);
        toast.error("Something went wrong. Please try again.");
    } finally {
        setLoading(false);
    }
    };
    
    return (
        <>
        <Modal className="query-popup" show={show} onHide={onHide} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Body>
                <button className="popup-close" onClick={onHide}><Icons name="plus" /></button>
                <div className="row m-0">
                    <div className="col-lg-7 col-md-7 no-padd">
                        <div className="query-formbox">
                            <h4 className="heading">Let’s talk about designing your space.</h4>
                            
                            <form onSubmit={handleSubmit}>
                                <div className="form-field">
                                    <input value={postData.name} onChange={handleChange} type="text" name="name" placeholder="Name*" className="form-control" />
                                </div>
                    
                                <div className="form-field half-field">
                                    <input value={postData.email} onChange={handleChange} name="email" type="email" placeholder="Email*" className="form-control" />
                                </div>
                    
                                <div className="form-field half-field">
                                    <input value={postData.mobile} onChange={handleChange} name="mobile" type="tel" maxLength={10} placeholder="Phone*" className="form-control" />
                                </div>
                    
                                <div className="form-field half-field">
                                    <select value={postData.project_type} onChange={handleChange} name="project_type" className="form-control">
                                        <option value="">Project Type*</option>
                                        <option value={"Residential"}>Residential</option>
                                        <option value={"Commercial"}>Commercial</option>
                                        <option value={"Renovation"}>Renovation</option>
                                    </select>
                                </div>

                                <div className="form-field half-field">
                                    <input value={postData.item_requirement} onChange={handleChange} type="text" name="item_requirement" placeholder="Item Requirement*" className="form-control" />
                                </div>
                    
                                <div className="form-field">
                                    <input value={postData.address} onChange={handleChange} type="text" name="address" placeholder="Address*" className="form-control" />
                                </div>
                    
                                <div className="form-field">
                                    <input value={postData.location} onChange={handleChange} type="text" name="location" placeholder="City / Location*" className="form-control" />
                                </div>
                    
                                <div className="form-field">
                                    <textarea value={postData.messages} onChange={handleChange} name="messages" placeholder="Your Message" className="form-control" />
                                </div>
                    
                                <div>
                                    <button type="submit" className="default-btn colored-btn">
                                        {loading ? "submitting..." : "Book a consultation now"} <Icons name="Longarrow_right" />
                                    </button>
                                </div>
                            </form> 
                        </div>
                    </div>

                    <div className="col-lg-5 col-md-5 no-padd">
                        <div className="querypop-image">
                            <img src="/image/query-image.webp" alt="query" className="img-responsive" />
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
        </>
    )
}
